// apps/web/src/configs/AppConfig.js
import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR,
} from "constants/ThemeConstant";

export const APP_NAME = "NLB Soluções";

export const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "/api"
    : process.env.REACT_APP_API_URL || "http://localhost:3001";

export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";

export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`;
export const UNAUTHENTICATED_ENTRY = `${AUTH_PREFIX_PATH}/login`;

export const REDIRECT_URL_KEY = "redirectUrl";

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: "en",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#ffffff",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
};

const AppConfig = {
  APP_NAME,
  API_BASE_URL,
  APP_PREFIX_PATH,
  AUTH_PREFIX_PATH,
  AUTHENTICATED_ENTRY,
  UNAUTHENTICATED_ENTRY,
  REDIRECT_URL_KEY,
  THEME_CONFIG,
};

export default AppConfig;